const el=(tag,text,parent,attrs={})=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;Object.assign(n,attrs);parent?.append(n);return n;};
let auditSeq=0;
export async function openProjectAudit(projectId){
 const token=++auditSeq;
 const host=document.getElementById('projectAuditPage');
 if(!host)throw new Error('找不到操作紀錄頁面');
 if(!projectId){host.replaceChildren();el('p','請先選擇專案',host);return;}
 const request=async path=>{const r=await fetch(path),value=await r.json();if(!r.ok)throw new Error(value.error||'專案設定讀取失敗');return value;};
 const url=`/api/auth/projects/${projectId}`;
 const [data,auditData]=await Promise.all([request(url),request(url+'/audit')]);
 if(token!==auditSeq)return;
 host.replaceChildren();
 el('h3',`操作紀錄 · ${data.project.name}`,host);
 el('h4','專案操作紀錄',host);el('p',auditData.window,host);
 if(!auditData.items.length)el('p','尚無可顯示的專案紀錄。',host);
 for(const event of auditData.items)el('p',`${new Date(event.at).toLocaleString()} · ${data.users.find(u=>u.id===event.actorId)?.displayName||event.actorId||'系統'} · ${event.summary||event.action}${event.status?'／HTTP '+event.status:''}`,host);
}
